import { render, staticRenderFns } from "./formview.vue?vue&type=template&id=70023d26&scoped=true&"
import script from "./formview.vue?vue&type=script&lang=js&"
export * from "./formview.vue?vue&type=script&lang=js&"
import style0 from "./formview.vue?vue&type=style&index=0&id=70023d26&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70023d26",
  null
  
)

export default component.exports